import { render } from "./send-pick-category-option-message-section.vue?vue&type=template&id=077236c8&lang=pug"
import script from "./send-pick-category-option-message-section.vue?vue&type=script&setup=true&lang=js"
export * from "./send-pick-category-option-message-section.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__